module.exports = __webpack_public_path__ + "img/柔性供应bg.5d0040e5.png";